import React from 'react'
import Layout from '../components/layout'
import Seo from '../components/seo'
import { graphql } from 'gatsby'
import NewsFeed from '../components/newsFeed'
import Spacer from '../components/spacer'


export default function News({ data }) {
    const { news } = data
    return (
        <Layout>
            <Seo title='News' />

            <NewsFeed news={news} />
            <Spacer />
          
        </Layout>
    )
}


export const query = graphql`
    query NewsPage{
        page:datoCmsNewsPage{
            nextPage{
                ...NextPage
            }
        }
        news:allDatoCmsNews {
            nodes {
                title
                slug
                website
                category {
                    name
                }
                meta {
                    publishedAt(formatString: "DD MMM Y")
                }
            }
        }
    }
`
